// Module
var code = "<template> <button class=\"${styles.button}\" type=\"button\" click.delegate=\"onClickVersion($event)\"> <span> <span class=\"sr-only\">Version Number: </span> <span> ${ backendVersion.versionNumber } </span> <br/> </span> <span class=\"sr-only\"> Build Date: ${ backendVersion.buildDate } <br/> </span> </button> </template> ";
// Exports
export default code;